module.exports = __webpack_public_path__ + "static/VMU_Mindaugas_Petkevicius-a9c3f61ee5282dbd642c18d270ed265d.jpg";